// This file was auto generated by resource-sync tools.

import en_shop_set_web from './en/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import en_account_web from './en/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';


const resources = {
    'en': {
        shop_set_web: en_shop_set_web,
        account_web: en_account_web
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        account_web: zh_account_web
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        account_web: zhHK_account_web
    }
};

export default resources;